import { render } from "./RarityRank.vue?vue&type=template&id=10aaaf8c"
import script from "./RarityRank.vue?vue&type=script&lang=js"
export * from "./RarityRank.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__